<template>
    <ui-modal
        :name="$mx_getModalName"
        :load-success="loader.modalLoadSuccess"
        :load="loader.modalLoad"
        title="Selecionar Usuários"
        icon="fal fa-user-circle"
        size="xxs"
    >
        <div class="search-content">
            <ui-search-box :event="searchEvent" placeholder="Buscar Usuário" />
        </div>

        <div class="wrapper-block">
            <ui-user-wrapper-list
                v-model="form.userList"
                :loading="loader.users"
                @scroll="loadUsers"
            />
        </div>
        <template #footer>
            <div class="cancel-buttons">
                <ui-modal-cancel-button :modal-name="$mx_getModalName"
                >Cancelar</ui-modal-cancel-button
                >
            </div>
            <ui-button
                :disabled="!canSubmit"
                type="button"
                design="md success mw-100"
                @click="submit"
            >Adicionar</ui-button
            >
        </template>
    </ui-modal>
</template>

<script>
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiSearchBox } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'
	import { uiUserWrapperList } from '@/components/ui-facilita/wrapper'

	import { loaderMixin, alertMixin, modalMixin, utilMixin, helpersMixin } from '@/mixins'

	import { user } from '@/services/axios'
	import { storage } from '@/services/storage'

	const defaultForm = () => ({
		id: null,
		userList: [],
		selectedsUserList: [],
		per_page: 8,
		last_page: 1,
		page: 1,
		search: '',
		closeEventName: '',
	})

	const defaultLoader = () => ({
		modalLoad: false,
		modalLoadSuccess: false,
		users: false,
	})

	export default {
		name: 'ui-select-users-modal',

		components: {
			uiModal,
			uiModalCancelButton,
			uiButton,
			uiUserWrapperList,
			uiSearchBox,
		},

		mixins: [loaderMixin, alertMixin, modalMixin, utilMixin, helpersMixin],

		props: {
			name: {
				type: String,
				required: true,
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				loader: { ...defaultLoader() },
				searchEvent: 'search-select-user-modal',
				groups: {
					admin: storage.get('label_admin'),
					collaborator: storage.get('label_collaborator'),
					supervisor: storage.get('label_supervisor'),
					manager: storage.get('label_manager'),
					broker: storage.get('label_broker'),
				},
			}
		},

		computed: {
			canSubmit() {
				return true
			},

			selectedsIds() {
				return this.form.selectedsUserList.map((user) => user.id)
			},
		},

		mounted() {
			this.$root.$on(
				'modal-open-' + this.$mx_getModalName,
				/**
				 * @param {Array} userList
				 */
				async (data) => {
					this.reset()
					this.form.closeEventName = data.closeEventName
					this.form.selectedsUserList = data.userList

					await this.loadUsers()
				},
			)

			this.$root.$on(this.searchEvent, async (search) => {
				this.form.last_page = 1
				this.form.page = 1
				this.form.userList = []
				this.form.search = search
				await this.loadUsers()
			})
		},

		beforeDestroy() {
			this.$mx_closeModal()
			this.$root.$off(this.searchEvent)
		},

		methods: {
			// closeAnimation() {
			// 	setTimeout(() => {
			// 		this.$mx_setLoader('modalLoadSuccess', true)

			// 		setTimeout(() => {
			// 			this.$mx_closeModal()
			// 			this.$mx_reloadTablePage()
			// 		}, 1000)
			// 	}, 500)
			// },

			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
			},

			async submit() {
				if (!this.canSubmit) return

				const selectedUsers = this.form.userList.filter((item) => {
					if (item.check) return item
				})

				this.$root.$emit(this.form.closeEventName, selectedUsers)
				this.$mx_closeModal()
			},

			async loadUsers() {
				if (this.form.page > this.form.last_page) return

				this.$mx_setLoader('users', true)
				const params = {
					groups: null,
					teams: null,
					supervisors: null,
					manager: null,
					per_page: this.form.per_page,
					page: this.form.page,
					q: this.form.search,
				}
				let response = await user.getAll('filter', params).catch((error) => {
					this.$mx_alertThisOnError(error)

					return []
				})

				if (response.data.data.length) {
					this.form.page = response.data.current_page + 1
					this.form.last_page = response.data.last_page

					response = response.data.data.map((item) => {
						return {
							id: item.id,
							name: item.first_name,
							group: this.getFormattedGroup(item.group),
							image: this.getImgCDN(item.photo),
							check: this.selectedsIds.includes(item.id),
						}
					})
				}

				if (response.length) {
					this.form.userList = this.form.userList.concat(response)
				}

				this.$mx_setLoader('users', false)
			},

			getFormattedGroup(group) {
				let groupLabel = ''

				switch (group) {
					case 'admin':
					case 'supervisor':
					case 'collaborator':
					case 'manager':
					case 'broker':
						groupLabel = this.groups[group]
						break

					default:
						groupLabel = group
						break
				}

				return groupLabel
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
